import { Link } from "react-router-dom";
import { PageMeta } from "@/components/PageMeta";
import { ContentPageShell, Prose } from "@/components/ContentPageShell";

export default function About() {
  return (
    <>
      <PageMeta
        title="O Tipomaticu — proč a pro koho jsme aplikaci postavili"
        description="Tipomatic je česká aplikace pro soukromé tipovací ligy na MS ve fotbale. Přečtěte si, kdo za projektem stojí, proč vznikl a kam směřuje."
        path="/about"
      />
      <ContentPageShell>
        <h1 className="text-3xl md:text-4xl font-bold mb-6">O Tipomaticu</h1>
        <Prose>
          <p>
            <strong>Tipomatic</strong> je česká webová aplikace pro tipování zápasů velkých fotbalových turnajů —
            primárně mistrovství světa a mistrovství Evropy. Nejsme sázková kancelář, nevyplácíme peníze, nesbíráme
            kurzové vklady. Jsme jednoduchý nástroj, který umožní partě kamarádů, kolegům v kanceláři nebo rodině
            hrát vlastní tipovací soutěž o body, respekt a případně o kávu.
          </p>

          <h2>Proč Tipomatic vznikl</h2>
          <p>
            Před každým velkým turnajem se opakoval stejný scénář: sdílená Excel tabulka v cloudu, tři různé verze,
            spory kdo co napsal, ruční přepočet bodů a někdo si vždycky stěžoval, že "tenhle tip byl přece jinak".
            Existující tipovací hry jsou buď navázané na sázkovky (a nutí registraci a vklad), nebo jsou
            neohrabaně komerční a plné reklamy.
          </p>
          <p>
            Chtěli jsme něco, co je{" "}
            <strong>zdarma</strong>, <strong>soukromé</strong> (do vaší ligy se dostane jen ten, komu pošlete
            pozvánku), <strong>přehledné na mobilu</strong> a co dělá jednu věc pořádně: sbírá tipy před výkopem,
            uzamkne je, po zápase spočítá body podle vašich pravidel a ukáže žebříček.
          </p>

          <h2>Co Tipomatic umí</h2>
          <ul>
            <li>
              <strong>Soukromé ligy s vlastními pravidly.</strong> Admin ligy nastaví bodování za přesný výsledek,
              tendenci nebo rozdíl gólů a může pravidla kdykoli upravit — všichni hráči dostanou notifikaci.
            </li>
            <li>
              <strong>Bulk tipování.</strong> Všechny zápasy skupinové fáze můžete natipovat najednou v jedné
              obrazovce a upravovat je dokud nezačne konkrétní zápas.
            </li>
            <li>
              <strong>Automatické uzamčení.</strong> Vteřinu před výkopem se tip zamkne. Žádné podvody, žádné
              spory.
            </li>
            <li>
              <strong>Progresivní web app.</strong> Nainstalujete si Tipomatic jako aplikaci na iOS i Android bez
              obchodu s aplikacemi. Notifikace o výsledcích chodí přímo na plochu.
            </li>
            <li>
              <strong>Vícejazyčnost.</strong> Aplikace funguje česky i anglicky, hodí se tedy i pro mezinárodní
              týmy.
            </li>
          </ul>

          <h2>Kdo za projektem stojí</h2>
          <p>
            Tipomatic staví <strong>Lukáš Skywalker</strong> v rámci komunitního projektu{" "}
            <Link to="/credits">Incubator</Link> — místa, kde vznikají malé užitečné produkty s otevřeným
            vývojovým procesem. Podrobný profil autora, kontakty a možnost projekt finančně podpořit najdete na
            stránce <Link to="/credits">Kdo za tím stojí</Link>.
          </p>

          <h2>Jak se financujeme</h2>
          <p>
            Aplikace je pro hráče zdarma a taková zůstane. Provoz a další vývoj hradíme z drobných darů přes
            Buy me a Coffee a z nenáročné bannerové reklamy Google AdSense zobrazované mimo hlavní herní obrazovky.
            Reklama nikdy nezasahuje do samotného tipování ani žebříčku. Podrobnosti o zpracování dat najdete v{" "}
            <Link to="/privacy">Zásadách ochrany osobních údajů</Link>.
          </p>

          <h2>Roadmap</h2>
          <p>
            Nejbližší priority: statistiky hráče napříč turnaji, sdílené žebříčky mezi ligami, integrace s
            oficiálním rozpisem FIFA a kompletní přepracování designu pro tablet. Máte návrh? Napište nám na
            stránce <Link to="/contact">Kontakt</Link> — ozveme se do 72 hodin.
          </p>
        </Prose>
      </ContentPageShell>
    </>
  );
}
